import { isEmbeddedRoute } from "~/utils/route_helpers";

const DEFAULT_OFFSET = 120;

const getScrollTop = (element: HTMLElement) => {
  const top = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

  return top - DEFAULT_OFFSET;
};

type ScrollTo = {
  behavior: ScrollBehavior;
  top: number;
};

export const scrollToElement = (element: HTMLElement | null) => {
  if (!element) {
    return;
  }

  const scrollTo: ScrollTo = {
    behavior: "smooth",
    top: getScrollTop(element),
  };

  if (isEmbeddedRoute(window?.location.pathname || "")) {
    window.parent.postMessage({ scrollTo }, "*");
  } else {
    window.scrollTo(scrollTo);
  }
};
